import axios from "axios";
import { baseUrl, azilisSwitchToBool } from "../util";

// Flow 44 - Waste Processing Form Data
export const getWasteProcessing44LCA = ({
  productId,
  setData = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/waste-processing-44-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setData(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching waste processing 44:", error);
      setData(null);
    });
};

export const updateWasteProcessing44LCA = ({
  productId,
  system_boundary,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/waste-processing-44-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      system_boundary: system_boundary || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Waste Processing 44 data updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating waste processing 44:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update waste processing 44 data",
          icon: "error",
          button: "OK",
        });
      }
    });
};

// Flow 44 Totals
export const getWasteProcessing44Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/waste-processing-44-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching waste processing 44 totals:", error);
      setTotals(null);
    });
};

// Flow 44.1 - Waste processes preparing for final treatment
export const getAllFlow44_1LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-44-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 44.1:", error);
      setObjects([]);
    });
};

export const addFlow44_1LCA = ({
  productId,
  name_part_in_fu,
  describe_process,
  how_is_part_processed,
  quantity_per_fu,
  next_waste_process_scenario,
  collecting_scenario,
  surplus_material_replaces_new_purchase,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-44-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_part_in_fu: name_part_in_fu || null,
      describe_process: describe_process || null,
      how_is_part_processed: how_is_part_processed || null,
      quantity_per_fu: quantity_per_fu || 0,
      next_waste_process_scenario: next_waste_process_scenario || null,
      collecting_scenario: collecting_scenario || null,
      surplus_material_replaces_new_purchase: azilisSwitchToBool(
        surplus_material_replaces_new_purchase
      ),
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 44.1 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 44.1:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 44.1 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow44_1LCA = ({
  productId,
  rowId,
  name_part_in_fu,
  describe_process,
  how_is_part_processed,
  quantity_per_fu,
  next_waste_process_scenario,
  collecting_scenario,
  surplus_material_replaces_new_purchase,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-44-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_part_in_fu: name_part_in_fu || null,
      describe_process: describe_process || null,
      how_is_part_processed: how_is_part_processed || null,
      quantity_per_fu: quantity_per_fu || 0,
      next_waste_process_scenario: next_waste_process_scenario || null,
      collecting_scenario: collecting_scenario || null,
      surplus_material_replaces_new_purchase: azilisSwitchToBool(
        surplus_material_replaces_new_purchase
      ),
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 44.1 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 44.1:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 44.1 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow44_1LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-44-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      window.swal({
        title: "Success!",
        text: "Flow 44.1 item deleted successfully",
        icon: "success",
        button: "OK",
      });
    })
    .catch(function (error) {
      console.error("Error deleting flow 44.1:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 44.1 item",
        icon: "error",
        button: "OK",
      });
    });
};

